import loadjs from "loadjs";
let templateDirectory = am2.templateDirectory;

export default function () {

$(".quantity__button").on("click", function(ev) {
    ev.preventDefault();
    var qty = $(".js-quantity-single");
    var qty = $(".qty");
    var val = parseFloat(qty.val());
    var max = parseFloat(qty.attr("max"));
    var min = parseFloat(qty.attr("min"));
    var step = parseFloat(qty.attr("step"));
    if ($(this).hasClass("js-quantity-increase")) {
      if (max && max <= val) {
        qty.val(max);
      } else {
        qty.val(val + step);
      }
    } else {
      if (min && min >= val) {
        qty.val(min);
      } else if (val > 1) {
        qty.val(val - step);
      }
    }

    $('.woocommerce').on('change', 'input.qty', function(){
      $("[name='update_cart']").trigger("click");
    });
    
  });

}
